export default __webpack_public_path__ + "static/media/network5.d23c01bb.svg";